import { Outlet, Navigate } from "react-router-dom";
import { Cpu, SlidersHorizontal, KeyRound } from "lucide-react";
import SettingsSectionNav from "../../components/Settings/SettingsSectionNav";
import UIStore from "../../store/uiStore";
import ROUTES from "../../router/routes";

const ModelGardenLayout = () => {
  const isAdmin = UIStore((state) => state.orgAvailable) === true;

  const navItems = [
    { path: ROUTES.SETTINGS.MODELS_CATALOG, label: "Model Catalog", icon: Cpu      },
    ...(isAdmin
      ? [
          { path: ROUTES.SETTINGS.MODELS_CONFIG,     label: "Model Config",    icon: SlidersHorizontal },
          { path: ROUTES.SETTINGS.MODELS_PROVIDERS,  label: "Provider Config", icon: KeyRound          },
        ]
      : []),
  ];

  return (
    <div className="flex w-full h-full">
      {/* Left nav — visible on md+ */}
      <div className="hidden md:flex flex-col w-52 flex-shrink-0 border-r border-edge-gray-200 dark:border-edge-dialog-border pt-5 pb-6 px-3 gap-1">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-ink-gray-400 dark:text-ink-gray-500 px-3 mb-2">
          Model Garden
        </p>
        <SettingsSectionNav items={navItems} />
      </div>

      {/* Main content */}
      <div className="flex-1 min-w-0 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
};

export const ModelGardenIndexRedirect = () => (
  <Navigate to={ROUTES.SETTINGS.MODELS_CATALOG} replace />
);

export default ModelGardenLayout;
